import { IconButton } from '@material-ui/core';
import { Tooltip } from 'antd';
import React from 'react';
import { useTranslate } from 'react-admin';
import { Refresh } from '@material-ui/icons';
import { useGetNoPageListData } from '../../../../base/components/customized/CustomizedNoPageList';
import resourceSlug from '../../../../constant/resource-slug';
import { useRegenerateInvoice } from '../../hooks';

const RegenerateButton = ({ invoiceId }) => {
  const t = useTranslate();
  const { refetchListData } = useGetNoPageListData(resourceSlug.INVOICE);

  const {
    isRegenerating,
    regenerateInvoice,
    invoiceId: regeneratedInvoiceId,
  } = useRegenerateInvoice({
    onSuccess: refetchListData,
  });

  return (
    <Tooltip title={t('resources.invoice.regenerate')}>
      <IconButton
        disabled={isRegenerating && regeneratedInvoiceId === invoiceId}
        onClick={(e) => {
          e.stopPropagation();
          regenerateInvoice(invoiceId);
        }}
        size="small"
      >
        <Refresh />
      </IconButton>
    </Tooltip>
  );
};

export default RegenerateButton;
